module.exports = __webpack_public_path__ + "img/watergater-flow-animation (1).ffa1521a.gif";